import { IGoalDatapointLatest } from "motw_core/DTOs/goaldatapointlatest";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import * as styles from "source/app/presentation/MainPanel/Goals/GoalCards/GoalCards.css";
import { IsGoalBleeding } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/IsGoalBleeding";
import { GoalDaysLeft } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/DaysLeft/GoalDaysLeft";
import { GameIdentityIcon } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/GameIdentityIcon/GameIdentityIcon";
import { GoalName } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/GoalName/GoalName";
import { GoalWeeklyRate } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/GoalWeeklyRate/GoalWeeklyRate";
import { GoalCardsIcon } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/Body/Icon/GoalCardsIcon";
import { IGoalStreakInfoDTO } from "../../../../../../../../../../motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO";

export function GoalCardBody({
    goal,
    isGameIdentityGoal,
    goalDatapointLatest,
    goalStreakInfo,
}: {
    goal: IGoal;
    isGameIdentityGoal: boolean;
    goalDatapointLatest?: IGoalDatapointLatest;
    goalStreakInfo?: IGoalStreakInfoDTO;
}) {
    if (!goalStreakInfo) {
        console.log(`No goal streak info found for the goal ${goal.name}`);
        return null;
    }

    const isGoalBleeding = IsGoalBleeding(goal);

    return (
        <div id="goalCardBody" className={styles.goalCardBody}>
            <GoalCardsIcon goal={goal} />
            <GoalName goal={goal} isGoalBleeding={isGoalBleeding} />
            <GoalDaysLeft
                goal={goal}
                daysleft={goal.daysleft}
                styles={styles}
                realMomentum={goalStreakInfo?.realMomentum}
            />
            <GoalWeeklyRate
                goal={goal}
                goalDatapointLatest={goalDatapointLatest}
                goalStreakInfo={goalStreakInfo}
            />
            <GameIdentityIcon isGameIdentityGoal={isGameIdentityGoal} />
        </div>
    );
}
